import init from '../../../js/init';
import { Screen } from '../../../js/variables';

const name = 'travel-cost-calculator';
const selector = '.travel-cost-calculator';
const formSelector = `${selector}__form`;
const rateSelector = `${selector}__rate`;
const airportCheckboxSelector = `${selector}__checkbox`;
const estimateBtnSelector = `${selector}__estimate-btn`;
const resetBtnSelector = `${selector}__reset-btn`;
const modalSelector = `${selector}__modal .modal`;
const pricesDesktopSelector = `${selector}__prices-desktop`;
const pricesMobileSelector = `${selector}__prices-mobile`;
const pricesTableSelector = `${selector}__prices-table`;
const pricesTableBestPriceClass = `${pricesTableSelector}--best-price`.substring(1);
const priceCardsSelector = `${selector}__price-cards`;
const bestDealSelector = `${selector}__best-deal`;
const notBestDealSelector = `${selector}__not-best-deal`;
const loaderSelector = `${selector}__loader`;
const errorSelector = `${selector}__error`;
const errorMessageSelector = `${selector}__error-message`;
const errorCloseBtnSelector = `${selector}__error-close`;

const priceProps = [
  { label: 'Round Trip Fare', key: 'ticket_cost', type: 'price' },
  { label: 'Airport Parking', key: 'parking_cost', type: 'price' },
  { label: 'Travel Time', key: 'travel_time', type: 'time' },
  { label: 'Travel Cost', key: 'travel_cost', type: 'price' },
  { label: 'Worth Your Time Cost', key: 'worth_your_time_cost', type: 'price' },
  { label: 'Total', key: 'final_cost', type: 'price' },
];

init(Drupal, name, selector, root => {
  const form = root.querySelector(formSelector);
  const airports = JSON.parse(root.getAttribute('data-airports'));
  const apiUrl = root.getAttribute('data-api');
  const formElementWrapper = form.querySelectorAll('.form-element');
  const checkboxes = root.querySelectorAll(airportCheckboxSelector);
  const estimateBtn = root.querySelector(estimateBtnSelector);
  const resetBtn = root.querySelector(resetBtnSelector);
  const modal = root.querySelector(modalSelector);
  const pricesDesktopElem = root.querySelector(pricesDesktopSelector);
  const pricesMobileElem = root.querySelector(pricesMobileSelector);
  const pricesTable = root.querySelector(pricesTableSelector);
  const priceCards = root.querySelector(priceCardsSelector);
  const addressInput = form.querySelector('input[name="address"]');
  const departureDateInput = form.querySelector('input[name="departureDate"]');
  const returnDateInput = form.querySelector('input[name="returnDate"]');
  const numberOfDaysInput = form.querySelector('input[name="numberOfDays"]');
  const destinationInput = form.querySelector('input[name="destination"]');
  const errorElem = root.querySelector(errorSelector);
  const errorMessageElem = root.querySelector(errorMessageSelector);
  const errorCloseBtn = root.querySelector(errorCloseBtnSelector);

  const widgetMode = numberOfDaysInput ? 'simple' : 'full';

  let selectedAirports = ['ontario'];

  function getFormValues() {
    const values = {};
    const formData = new FormData(form);
    for (const [key, value] of formData.entries()) values[key] = value;
    return values;
  }

  function getRateElem(airportValue) {
    return root.querySelector(`${rateSelector}[data-airport="${airportValue}"]`);
  }

  function updateAirportCheckboxes(values) {
    const checkedValues = Object.keys(values).filter(k => k.startsWith('airports-'));

    for (const checkbox of checkboxes) {
      if (checkedValues.includes(checkbox.name)) continue;

      checkbox.disabled = widgetMode === 'simple' ?
        checkedValues.length === 2 || !values.address || !values.numberOfDays :
        checkedValues.length === 2 || !values.address || !values.departureDate || !values.returnDate || !values.departureTime || !values.returnTime;
    }

    selectedAirports = ['ontario', ...checkedValues.map(value => value.replace('airports-', ''))];

    if (selectedAirports.length > 1) {
      document.getElementById('error-ariports-compare').classList.add('hidden');
    }
    else {
      document.getElementById('error-ariports-compare').classList.remove('hidden');
    }

    if (selectedAirports.every((airport) => !!values[`rates-${airport}`])) {
      document.getElementById('error-no-fare').classList.add('hidden');
    }
    else {
      document.getElementById('error-no-fare').classList.remove('hidden');
    }
  }

  function updateRateInputs(values) {
    airports.forEach((airport, i) => {
      const rateElem = getRateElem(airport.value);
      const input = rateElem.querySelector('input');

      if (i !== 0)
        rateElem.classList.toggle('hidden', !values[`airports-${airport.value}`]);

      if (widgetMode === 'simple') {
        input.toggleAttribute('disabled', !values.address || !values.numberOfDays)
      }
      else {
        input.toggleAttribute('disabled', !values.address || !values.departureDate || !values.returnDate || !values.departureTime || !values.returnTime)
      }
    });
  }

  function updateButtons(values) {
    estimateBtn.disabled = widgetMode === 'simple' ?
      !(values.address && values.numberOfDays && selectedAirports.every((airport) => !!values[`rates-${airport}`])) :
      !(values.address && values.departureDate && values.departureTime && values.returnDate && values.returnTime && selectedAirports.every((airport) => !!values[`rates-${airport}`]));

  }

  function resetRates() {
    root.querySelectorAll(`${rateSelector} input`).forEach(input => {
      input.value = '';
    });
  }

  function formChanged(e) {
    const values = getFormValues();
    updateAirportCheckboxes(values);
    updateRateInputs(values);
    updateButtons(values);

    resetBtn.classList.add('hidden');

    handleFormElementChange();
  }

  function getColumnStr(val, type) {
    if (type === 'price')
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(val);
    else if (type === 'time') {
      val = +val;

      if (!val) return '0';

      const hours = Math.floor(val);
      const minutes = Math.floor((val % 1) * 60);

      const hoursStr = `${hours} Hour${hours === 1 ? '' : 's'}`;
      const minutesStr = `${minutes} Minute${minutes === 1 ? '' : 's'}`;

      let res = '';

      if (hours > 0) res = hoursStr;
      if (res) res += '<br>'
      if (minutes > 0) res += minutesStr;

      return res;
    }

    return val;
  }

  function renderPricesTable(prices, bestPrice) {
    const columns = selectedAirports.map(airport => airports.find(a => a.value === airport).name);

    const rows = priceProps.map(({ label, key, type }) => {
      return [
        label,
        ...selectedAirports.map(airport => {
          let val = prices[airport][key];
          return getColumnStr(val, type);
        }),
      ];
    });

    pricesTable.innerHTML = `
      <thead>
        <tr>
          <th></th>
          ${columns.map(column => `<th>${column}</th>`).join('')}
        </tr>
      </thead>
      <tbody>
        ${rows.map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`).join('')}
      </tbody>
    `;

    pricesTable.classList.toggle(pricesTableBestPriceClass, bestPrice);

    pricesDesktopElem.querySelector(bestDealSelector).classList.toggle('hidden', !bestPrice);
    pricesDesktopElem.querySelector(notBestDealSelector).classList.toggle('hidden', bestPrice);

    pricesDesktopElem.classList.remove('hidden');
  }

  function renderPricesCards(prices, bestPrice) {
    priceCards.innerHTML = selectedAirports
      .map(
        airport => `
      <div class="travel-cost-calculator__price-card">
        <span class="travel-cost-calculator__price-card-title">${
          airports.find(a => a.value === airport).name
        }</span>
        ${priceProps
          .map(
            ({ label, key, type }) => `
          <div class="travel-cost-calculator__price-card-row">
            <span>${label}</span>
            <span>${getColumnStr(prices[airport][key], type)}
            </span>
          </div>
        `
          )
          .join('')}
      </div>
    `
      )
      .join('');

    pricesMobileElem.querySelector(bestDealSelector).classList.toggle('hidden', !bestPrice);
    pricesMobileElem.querySelector(notBestDealSelector).classList.toggle('hidden', bestPrice);

    pricesMobileElem.classList.remove('hidden');
  }

  function renderPrices(prices) {
    const cheapest = [...selectedAirports].sort((a, b) => prices[a].final_cost - prices[b].final_cost)[0];
    const bestPrice = cheapest === 'ontario';

    renderPricesTable(prices, bestPrice);
    renderPricesCards(prices, bestPrice);
  }

  function showError(message) {
    errorMessageElem.innerHTML = message;
    errorElem.classList.remove('hidden');
    errorCloseBtn.onclick = errorCloseBtn.onclick || hideError;
  }

  function hideError() {
    errorMessageElem.innerHTML = '';
    errorElem.classList.add('hidden');
  }

  async function estimate() {
    if (selectedAirports.length < 2) {
      document.getElementById('error-ariports-compare').classList.remove('hidden');
      return;
    }

    const values = getFormValues();

    const comparisonAirports = {};

    for (const airport of airports)
      if (values[`rates-${airport.value}`])
        comparisonAirports[airport.value] = values[`rates-${airport.value}`];

    let data = null;

    setLoader(true);
    hideError();

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        body: JSON.stringify({
          address: values.address,
          destination: values.destination,
          departureDate: values.departureDate,
          departureTime: values.departureTime,
          returnDate: values.returnDate,
          returnTime: values.returnTime,
          days: values.numberOfDays,
          comparison_airports: comparisonAirports,
        })
      });
      setLoader(false);

      if (response.ok) {
        data = await response.json();
      } else {
        showError(response.statusText);
        return;
      }
    } catch (e) {
      setLoader(false);
      showError(e.message);
      return;
    }

    if (data.status === 'error') {
      showError(data.data);
      return;
    }

    if (window.innerWidth >= Screen.md) {
      const event = new Event('open');
      modal.dispatchEvent(event);
    }

    resetBtn.classList.remove('hidden');
    renderPrices(data.data);
  }

  function reset() {
    checkboxes.forEach(checkbox => checkbox.checked && checkbox.click());
    root
      .querySelectorAll('input')
      .forEach(input => input.type !== 'checkbox' && (input.value = ''));
    formChanged();
    pricesDesktopElem.classList.add('hidden');
    pricesMobileElem.classList.add('hidden');
    resetBtn.classList.add('hidden');
  }

  function listenToChanges() {
    form.oninput = formChanged;
    form.onchange = formChanged;
    estimateBtn.onclick = estimate;
    resetBtn.onclick = reset;
  }

  function setLoader(value) {
    const loader = root.querySelector(loaderSelector);
    loader.classList.toggle('hidden', !value);
  }

  function addAddressAutocomplete() {
    const options = {
      fields: ['address_components', 'geometry', 'icon', 'name'],
      strictBounds: false,
    };

    new google.maps.places.Autocomplete(addressInput, options);
    new google.maps.places.Autocomplete(destinationInput, options);
  }

  function showHideFormElementError(input, label) {
    const formElement = input.closest('label');
    let hasEmpty = false;
    formElement
      .querySelectorAll('input')
      .forEach(input => input.type !== 'checkbox' && !input.value && (hasEmpty = true));

    if (hasEmpty) {
      formElement.querySelector('.relative').classList.add('field--error');
      formElement.querySelector('.text-semantic-error').classList.remove('hidden')
    }
    else {
      formElement.querySelector('.relative').classList.remove('field--error');
      formElement.querySelector('.text-semantic-error').classList.add('hidden');
    }
  }

  function handleFormElementChange() {
    showHideFormElementError(addressInput, 'Your Address');
    if (widgetMode === 'full') {
      showHideFormElementError(departureDateInput, 'Departure Date');
      showHideFormElementError(returnDateInput, 'Return Date');
    }
    else {
      showHideFormElementError(numberOfDaysInput, 'Number of Days');
    }
  }

  addAddressAutocomplete();
  updateAirportCheckboxes({});
  updateRateInputs({});
  listenToChanges();

  formElementWrapper.forEach((ele) => {
    ele.querySelector('.relative').classList.remove('field--error');

    form
      .querySelectorAll('.text-semantic-error')
      .forEach(item => item.classList.add('hidden'));

    ele.onclick = () => handleFormElementChange();
  });

});
